import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa";
import { FaPinterestP } from "react-icons/fa";
import { FaLink } from "react-icons/fa"; // 🔗 Copy link icon
import "./socialShare.scss";
import { useIncrementShareCountMutation } from "../../features/api/videoApiSlice";
import { useState } from "react";

// ✅ Always share the backend meta endpoint
// ✅ Meta endpoint for crawlers
const getMetaUrl = (videoId) =>
  `https://www.tipstoolstechniques.com/api/meta/${videoId}/meta`;

// ✅ Direct video route for humans
// ✅ Always share the canonical video URL directly
const getVideoUrl = (videoId) =>
  `https://www.tipstoolstechniques.com/watch/${videoId}`;

// Generate share URLs
const generateShareUrl = (platform, videoId, videoTitle) => {
  const shareVideoUrl = getVideoUrl(videoId);
  const encodeTitle = encodeURIComponent(videoTitle);

  switch (platform) {
    case "facebook":
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        shareVideoUrl
      )}`;
    case "twitter":
      return `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        shareVideoUrl
      )}&text=${encodeTitle}`;
    case "linkedin":
      return `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(
        shareVideoUrl
      )}&title=${encodeTitle}`;
    case "whatsapp":
      return `https://api.whatsapp.com/send?text=${encodeTitle} ${shareVideoUrl}`;
    case "pinterest":
      return `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
        shareVideoUrl
      )}&media=&description=${encodeTitle}`;
    default:
      return "";
  }
};

const SocialShare = ({ videoId, videoTitle }) => {
  const [incrementShareCount] = useIncrementShareCountMutation();
  const [copied, setCopied] = useState(false);

  const handleShareClick = async (platform) => {
    try {
      await incrementShareCount(videoId);
      const url = generateShareUrl(platform, videoId, videoTitle);
      window.open(url, "_blank", "noopener,noreferrer");
    } catch (error) {
      console.error("Failed to track share:", error);
    }
  };

  const handleCopyLink = async () => {
    try {
      const videoUrl = getVideoUrl(videoId); // ✅ use direct URL for humans
      await navigator.clipboard.writeText(videoUrl);
      setCopied(true);
      await incrementShareCount(videoId);

      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error("Failed to copy link:", error);
    }
  };

  return (
    <div className="social-share">
      <div className="share">
        <a onClick={() => handleShareClick("facebook")}>
          <FaFacebookF />
        </a>
        <a onClick={() => handleShareClick("twitter")}>
          <FaXTwitter />
        </a>
        <a onClick={() => handleShareClick("linkedin")}>
          <FaLinkedinIn />
        </a>
        <a onClick={() => handleShareClick("pinterest")}>
          <FaPinterestP />
        </a>

        {/* Copy link with tooltip */}
        <div className="copy-link-wrapper">
          <a onClick={handleCopyLink}>
            <FaLink />
          </a>
          {copied && <span className="tooltip">Copied!</span>}
        </div>
      </div>
    </div>
  );
};

export default SocialShare;
